import { render } from "./MuziekView.vue?vue&type=template&id=3ae3b5d3"
import script from "./MuziekView.vue?vue&type=script&lang=js"
export * from "./MuziekView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__